//import FirstSocial from "../../components/FirstSocial";
import Buttondown from "../../components/Buttondown";
import Frase from "../../components/Frase";
import Carrusel from "../../components/Carrusel";
import style from "./landing.module.css";
import Cards from "../../components/Cards";
import Redes from "../../components/Redes";
import Eslogan from "../../components/Eslogan";
import Helmets from "../../widgets/Helmet";
import WhatsappButton from "../../components/whatsappbutton";

const Landing: React.FC = () => {
  return (
    <>
      <Helmets />
      <main className={style.Master}>
        <div className={style.Fotobanner}>
          <div className={style.FotoShadow}>
            <Frase />
            <Eslogan />
            <div className={style.Buttondwn}>
              <Buttondown />
            </div>
          </div>
        </div>
      </main>      
      <Carrusel />
      <Cards />
      <div className={style.BoxRedesFixed}>
        <Redes />
      </div>
      <WhatsappButton />
    </>
  );
};

export default Landing;
